export enum ListType {
    NONE = '',
    FOLIOS = 'folios',
    GRIDICS_IDS = 'gridicsIds',
    GROUP_IDS = 'groupIds'
}

export function getPrettyListType(taskType: number): string {
    return ['', 'List of Folios', 'List Of Gridics Ids'][taskType];
}
